<template>
    <simple-layout
        :modelsLoaded="true"
        :indicators="indicators"
        :img="backgroundFile2"
        :name="getVerbose('alarm_simple_layout_breadcrumb')"
    >
        <div class="box alarms-container" :class="{'dark-theme': darkMode}">
            <div
                class="box-body alarms"
                style="min-height: 200px;"
            >
                <div v-if="$store.getters.userIsAtLeastAdmin">
                    <div v-if="$store.getters.alarms.length == 0">
                        {{ getVerbose('alarm_empty') }}
                    </div>
                    <div v-else>
                        <div v-if="allowFilterAlarms && $store.getters.alarms.length > 1" class="filter-alarms-container">
                            <el-input
                                v-model="query"
                                :clearable="true"
                            >
                                <el-select
                                    slot="prepend"
                                    v-model="valueFilter"
                                    :placeholder="valueFilter.label"
                                    style="width: 160px"
                                    @change="updateAlarmsList"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-input>
                        </div>
                        <el-row
                            v-if="displayedSortedAlarms.length"
                            :gutter="10"
                            style="margin: 0;"
                        >
                            <alarm-item
                                v-for="alarm in displayedSortedAlarms"
                                :name="alarm.name"
                                :active="alarm.active"
                                :modification-date="alarm.modification_date"
                                :message="alarm.message"
                                :corrective-action-message="alarm.corrective_action_message"
                                :related-url="alarm.related_url || ''"
                                :level="alarm.level"
                                :key="alarm.uid"
                            ></alarm-item>
                        </el-row>
                        <div v-else>{{ getVerbose('alarm_filter_no_result') }}<strong>{{ query }}</strong>.</div>
                    </div>
                </div>
                <div v-else>
                    {{ getVerbose('alarm_no_permission') }}
                </div>
            </div>
        </div>
    </simple-layout>
</template>

<script>
import SimpleLayout from '../../partials/simple-layout.vue';
import AlarmCollapseItem from './alarmCollapseItem.vue';
import AlarmItem from './alarmItem.vue';
import {mapGetters} from 'vuex';

export default {

    components: { AlarmCollapseItem, AlarmItem, SimpleLayout },

    data () {
        return {
            displayedAlarms: [],
            showActiveAlarms: true,
            showInactiveAlarms: true,
            valueFilter: 'all',
            options: [
                {
                    value: 'all',
                    label: ''
                },
                {
                    value: 'active',
                    label: ''
                },
                {
                    value: 'inactive',
                    label: ''
                },
            ],
            query: '',

        };
    },

    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
            'backgroundFile2',
            'allowFilterAlarms',
            'getVerbose',
            'currentLang',
            'activeAlarms',
            'inactiveAlarms',
            'allAlarms',
            'darkMode',
        ]),
        displayedSortedAlarms (){
            return this.displayedAlarms.sort((a,b) => {
                if(new Date(a.modification_date) > new Date(b.modification_date)){
                    return -1;
                }else if (new Date(a.modification_date) < new Date(b.modification_date)){
                    return 1
                }
                return 0;
            });
        },

        filteredAlarms() {
            if(this.valueFilter === 'active') {
                return this.activeAlarms;
            } else if(this.valueFilter === 'inactive') {
                return this.inactiveAlarms;
            } else {
                return this.allAlarms;
            }
        },
        indicators() {
            return [
                {
                    title: this.activeAlarms.length,
                    subtitle: this.getVerbose('alarm_simple_layout_active_alarm_indicator'),
                },
                {
                    title: this.inactiveAlarms.length,
                    subtitle: this.getVerbose('alarm_simple_layout_inactive_alarm_indicator'),
                },
            ];
        }
    },

    watch: {
        query() {
            this.updateAlarmsList();
        },
        currentLang() {
            this.setOptionsLabel();
        }
    },

    mounted() {
        this.displayedAlarms = this.allAlarms;
        this.$nextTick(() => {
            this.setOptionsLabel();
        })
    },


    methods: {
        setOptionsLabel() {
            // can't access getters in data, so we need to set the traduction, this way until a better one is found
            let optionsLabel = [
                this.getVerbose('alarm_filter_select_option_all'),
                this.getVerbose('alarm_filter_select_option_active'),
                this.getVerbose('alarm_filter_select_option_inactive'),
            ];
            this.options.forEach((option, index) => {
                option.label = optionsLabel[index];
            });
        },
        updateAlarmsList() {
            if(this.query) {
                this.displayedAlarms = this.filteredAlarms.filter((alarm) => {
                    return alarm.name.toLowerCase().includes(this.query);
                });
            } else {
                this.displayedAlarms = this.filteredAlarms;
            }
        }
    }

};
</script>

<style lang="scss" module>
.settingsHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 65px;
}
</style>

<style lang="scss">
.alarms-container {
    margin: 0 !important; // otherwise can be overriden by `.box` margin-bottom
    .alarms {
        padding: 30px;
        .filter-alarms-container {
            margin-bottom: 20px;
        }

        .filter-alarms-label {
            display:inline-block;
        }

        .filter-alarms-input {
            display:inline-block;
            margin-left: 10px;
        }

        .filter-alarms-select {
            width: 300px;
        }
    }
    &.dark-theme {
        .alarms {
            background-color: #111111;
            color: #EAEBEF;
            .alarm-card {
                background-color: #2E3035;
                border-color: #aaaaaa;
                hr {
                    border-color: #aaaaaa;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alarms/index.vue